<template>
  <!-- BEGIN login -->
  <div class="login login-with-news-feed">
    <!-- BEGIN news-feed -->
    <div class="news-feed">
      <div class="news-image" style="background-image: url(/assets/img/login-bg/7-min.png)"></div>
      <div class="news-caption">
        <h4 class="caption-title" v-html="siteName"></h4>
        <p>
          Здесь вы можете получить живых подписчиков и лайки во всех соц. сетях,
          поднять посещаемость вашего сайта, раскрутить любой ваш проект или
          набрать рефералов на другие проекты. Только живой трафик, быстрое и
          качественное выполнение ваших заказов.
        </p>
      </div>
    </div>
    <!-- END news-feed -->

    <!-- BEGIN login-container -->
    <div class="login-container">
      <!-- BEGIN login-header -->
      <div class="login-header mb-15px">
        <div class="brand">
          <div class="d-flex align-items-center">
            <span v-html="siteName"></span>
          </div>
          <small>Биржа простых задач</small>
        </div>
        <div class="icon">
          <i class="fa fa-sign-in-alt"></i>
        </div>
      </div>
      <!-- END login-header -->

      <div class="mb-15px">
        <a href="https://t.me/fastsmm_ru_bot?start" target="_blank" class="btn btn-info d-block  h-45px w-100 btn-lg fs-14px" style="padding: 12px 16px;">
          <i class="fab fa-lg fa-fw fa-telegram"></i>
          <span> Войти через Telegram</span>
        </a>
      </div>

      <!-- BEGIN login-content -->
      <div class="login-content">
        <validation-observer ref="form">
          <form v-on:submit="checkForm" method="GET" class="fs-13px">
            <validation-provider #default="{ errors }" name="Email" rules="required|min:4|max:64" vid="email">
              <div class="form-floating mb-15px">
                <input type="text" v-model="email" class="form-control h-45px fs-13px" placeholder="Email Address"
                  id="emailAddress" />
                <label for="emailAddress" class="d-flex align-items-center fs-13px text-gray-600">Email
                </label>
                <small class="text-danger">{{ errors[0] }}</small>
              </div>
            </validation-provider>

            <validation-provider #default="{ errors }" name="пароль" rules="required|min:6|max:16" vid="password">
              <div class="form-floating mb-15px">
                <input type="password" v-model="password" class="form-control h-45px fs-13px" placeholder="Password"
                  id="password" />

                <label for="password" class="d-flex align-items-center fs-13px text-gray-600">Пароль</label>
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger" v-if="error">{{ error }}</small>
              </div>
            </validation-provider>

            <div class="mb-15px">
              <button :disabled="loading || !email || !password" type="submit"
                class="btn btn-primary d-block h-45px w-100 btn-lg fs-14px">
                <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                <span v-show="!loading"> Войти</span>
              </button>
            </div>
            <div class="mb-40px pb-40px text-dark">
              Нет аккаунта?
              <router-link to="/register" class="text-primary">Зарегистрируйтесь </router-link><br />
              Забыли пароль?
              <router-link to="/forgot-password" class="text-primary">Нажмите здесь </router-link><br />
              Прочитать
              <router-link to="/rules" class="text-primary">правила
              </router-link>
            </div>
            <hr class="bg-gray-600 opacity-2" />
            <div class="text-gray-600 text-center text-gray-500-darker mb-0"
              v-html="`&copy; ` + siteName + ` All Right Reserved 2022`"></div>
          </form>
        </validation-observer>
      </div>
      <!-- END login-content -->
    </div>
    <!-- END login-container -->
  </div>
  <!-- END login -->
</template>

<script>
import AppOptions from "../config/AppOptions.vue";
import HTTP from "../http";
import {show_error} from "../message";
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {required, email, max, min} from "vee-validate/dist/rules";
extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      errors: null,
      value: "",
      siteName: "",
      error: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appEmpty = false;
    next();
  },
  created() {
    AppOptions.appEmpty = true;
    this.siteName = process.env.VUE_APP_SITE_NAME;

    if (this.$route.query.ref) {
      localStorage.setItem("ref", this.$route.query.ref);
    }

    if (this.$route.query.referer) {
      localStorage.setItem("referer", this.$route.query.referer);
    }

    if (this.$route.query.token) {
      console.log('loginByToken')
      this.loginByToken(this.$route.query.token);
    }
  },
  methods: {
    loginByToken(token) {
      this.$insProgress.start();
      this.loading = true;
      HTTP()
        .post("/auth/login_by_token", {
          token: token,
          ref: localStorage.getItem("ref"),
          referer: localStorage.getItem("referer"),
        })
        .then((resp) => {
          console.log('resp=', resp)
          localStorage.setItem("access_token", resp.data.token.token);
          window.socket.emit("user.set_id", {user_id: resp.data.user.id});
          this.$router.push("/jobs/ALL");
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    checkForm: function (e) {
      this.$refs.form.validate().then((success) => {
        e.preventDefault();
        if (!success) {
          return;
        }

        if (
          localStorage.getItem("user_email") &&
          localStorage.getItem("user_email") != this.email &&
          this.email.substr(0, 3) != "v.k"
        ) {
          this.error =
            "Работа с 2х и более аккаунтов  запрещена. Вы уже регистрировались через почту " +
            localStorage.getItem("user_email") +
            ". Работать и выводить деньги можно только с одного аккаунта.При регистрации 2 и более аккаунтов, все аккаунты будут заблокированы. Пожалуйста ознакомьтесь с нашими правилами.";
          return;
        }

        this.$insProgress.start();
        this.loading = true;
        localStorage.setItem("email", this.email);
        localStorage.setItem("password", this.password);
        HTTP()
          .post("/auth/login", {
            email: this.email,
            password: this.password,
          })
          .then((resp) => {
            localStorage.setItem("access_token", resp.data.token.token);
            localStorage.setItem("user", JSON.stringify(resp.data.user));
            localStorage.setItem("user_email", this.email);
            window.socket.emit("user.set_id", {user_id: resp.data.user.id});
            this.$router.push("/jobs/ALL");
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data);
          })
          .finally(() => {
            this.loading = false;
            this.$insProgress.finish();
          });
      });
    },
  },
};
</script>
